import * as React from 'react'
import { Component } from 'react'

class Redirect extends Component {

    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <div className="redirect">
                <h1>404</h1>
                <h3>抱歉，你访问的页面不存在</h3>
            </div>
        );
    }
}
 
export default Redirect